import '../style/city-layout.scss'
export default {
  functional: true,
  render (h, context) {
    const [slots] = context.children
    const renderChild = () => {
      const { labelData, children } = context.props.renderData.reduce((obj, cur) => {
        const { _isLabel } = cur
        if (_isLabel) {
          obj.labelData.push(cur)
        } else {
          obj.children.push(cur)
        }
        return obj
      }, {
        labelData: [],
        children: []
      })
      return [
        labelData.length ? <div class="label-wrap">
          {
            labelData.map(item => {
              return slots.label({
                item,
                type: '_label'
              })
            })
          }
        </div> : null,
        <div class="child-wrap">
          {
            children.map(item => {
              return slots.cityItem({
                item
              })
            })
          }
        </div>,
      ]
    }
    const children = renderChild()
    return <div class='kye-area-city-layout'>
      {
        children
      }
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/layout/city-layout.js